module.exports = __webpack_public_path__ + "img/Emin_Guluyev.687d6315.jpg";